import React from 'react'

function ReviewFeaturebox1() {
    return (
        <div className='homebox2main' id='feature-box1'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-left'>
                        <img src="/img-engage.webp" alt="hero-img" />
                    </div>
                    <div className='homebox2-right'>
                        <span>Customer Reviews & References</span>
                        <h2>Trusted by Businesses, Loved by Users</h2>
                        <p>Our Staff Management system is trusted by businesses to simplify their daily operations and improve workforce efficiency. Customers appreciate its ease of use, reliability, and powerful management features that help them stay organized and productive.</p>
                        <h5>What Users Say About Us</h5>
                        <ul>
                            <li>Easy to use and saves a lot of time in managing staff records</li>
                            <li>Accurate attendance tracking with no manual effort</li>
                            <li>Helps improve employee productivity and management control</li>
                            <li>Reliable system for daily business operations</li>
                            <li>Great support and smooth user experience</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReviewFeaturebox1